
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/salary-guide",
      function () {
        return require("private-next-pages/reports/salary-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports/salary-guide"])
      });
    }
  